// var ol = omjs.ol;

/* 
    text_content
    text_fontsize
    text_fontcolor
*/


module.exports = function(style, zindex, scale) {
    
    // кружок для рисования
    var circle = new ol.style.Circle({
        radius: 1
    });

    var text_style = new ol.style.Text({
        text: style['text_content'],
        fill: new ol.style.Fill({
            color: style['text_fontcolor']
        }),
        font: style['text_fontsize'] + 'px sans-serif'
    });

    /* обычный стиль */
    var regular = new ol.style.Style({
        image : circle,
        text: text_style,
        zIndex: zindex
    });

    return [regular];
};



//////////////////
// WEBPACK FOOTER
// ./src/View/PublicMapDraw/text-style.js
// module id = 234
// module chunks = 0